export default "__VITE_ASSET__LzU6wNsZ__"